import React from 'react';
import ReactDOM from 'react-dom';
import ImgIconComp from '../../imgcomp';
import { withTranslation } from 'react-i18next';

class ViewDeletePopup extends React.Component {
  constructor(props) {
	super(props);
	this.state = {		
		meeting_recurring_type: 1		
	}
    this.closeWsPopup = this.closeWsPopup.bind(this);
	this.deleteMeetingPopUp = this.deleteMeetingPopUp.bind(this);
	this.onStateChanged = this.onStateChanged.bind(this);
  }
  
  onStateChanged(e, id) {		
    this.setState({		
		meeting_recurring_type: id,		
    });		
  }

  closeWsPopup() {
    if (document.getElementById('delete-meeting-confirm-box')) {
      ReactDOM.unmountComponentAtNode(document.getElementById('delete-meeting-confirm-box'));
    }
    $(delete_meeting_confirm).dialog('close');
  }

  deleteMeetingPopUp() {
    $(document).trigger('unmount_meeting_app_comp');
    const obj = $(this).closest('#delete-meeting-confirm-box');
    this.props.deleteMeeting(this.state.meeting_recurring_type);
  }

  render() {
	const { t } = this.props;
	let recurringEn = this.props.meetingObj.interval > 0 ? true : false;
    return (
      <div className="wbmodal" id="delete-meeting-confirm-box">
        <div className="delete-meeting-head">
          <div className="delete-meet-head left">
		  	<b>{t("Delete")}{recurringEn ? ' Recurring ' : ' '}{t("Meeting")}</b>
          </div>
          <div className="wbmodal-hcancel closeWsPopup clickable" onClick={this.closeWsPopup}>
            <ImgIconComp id="close" />
          </div>
          <div className="clear" />
        </div>
		<div className="Line"></div>
        {		
            recurringEn ?		
				<div className="meeting_recurring_enable">		
					<div className="wsBoardRadioStd">		
						<input type="radio" value="1" name="meeting_recurring_type" />		
						{		
							(this.state.meeting_recurring_type == 1)		
							? <div className="seleced-radio " />		
							: <div className="empty-radio" onClick={e => this.onStateChanged(e, 1)} />		
						}		
						<label className="wsRadioWs">{t("This meeting")}</label>		
					</div>		
					<div className="wsBoardRadioStd">		
						<input type="radio" value="2" name="meeting_recurring_type" />		
						{		
							(this.state.meeting_recurring_type == 2)		
							? <div className="seleced-radio " />		
							: <div className="empty-radio" onClick={e => this.onStateChanged(e, 2)} />		
						}		
						<label className="wsRadioWs">{t("This and following meetings")}</label>		
					</div>		
					<div className="wsBoardRadioStd">		
						<input type="radio" value="3" name="meeting_recurring_type" />		
						{		
							(this.state.meeting_recurring_type == 3)		
							? <div className="seleced-radio " />		
							: <div className="empty-radio" onClick={e => this.onStateChanged(e, 3)} />		
						}		
						<label className="wsRadioWs">{t("All meetings (including past meetings)")}</label>		
					</div>		
				</div>		
				:		
				<div className="notRecurring">		
					<span> {t("Are you sure you want to delete this meeting")}?</span>		
				</div>		
        }		
			<div className="Line"></div>		
			<div className="meeting-butn-wraper">		
				<div className="cancel-meeting-btn" onClick={this.closeWsPopup}>Cancel</div>		
				<div className="delete-meeting-btn" data-id={this.props.meetingObj.id} onClick={this.deleteMeetingPopUp}>Delete</div>		
			</div>
      </div>
    );
  }
}
export default withTranslation()(ViewDeletePopup);
